import React from "react";
import { PieChart, Pie, Cell, Tooltip as RechartsTooltip, ResponsiveContainer, Legend } from "recharts";
import AppTooltip from "components/Tooltip";

const COLORS = [
  "var(--color-accent)",
  "var(--color-success)",
  "var(--color-warning)",
  "#6366f1",
  "#06b6d4",
  "#ec4899",
];

const CONCENTRATION_THRESHOLD = 50; // %

const CustomTooltip = ({ active, payload }) => {
  if (active && payload && payload?.length) {
    return (
      <div className="bg-card border border-border rounded-lg p-3 shadow-lg">
        <p className="font-heading font-semibold text-sm text-foreground">{payload?.[0]?.name}</p>
        <p className="font-data text-xs text-muted-foreground">
          {payload?.[0]?.value?.toLocaleString("es-ES")} € ({payload?.[0]?.payload?.pct}%)
        </p>
      </div>
    );
  }
  return null;
};

export default function InventoryConcentration({ data }) {
  const topMetal = data?.[0];
  const hasConcentrationWarning = topMetal && topMetal?.pct >= CONCENTRATION_THRESHOLD;

  return (
    <div className="card p-4 lg:p-5 min-w-0">
      <div className="flex items-center justify-between mb-4">
        <AppTooltip
          title="Concentración por Metal"
          description="Distribución de tu exposición total entre los distintos metales. Una concentración alta en un único metal aumenta el riesgo si ese mercado cae."
        >
          <h3 className="font-heading font-semibold text-base text-foreground">Concentración Inventario</h3>
        </AppTooltip>
        <span className="text-xs font-caption text-muted-foreground">por metal</span>
      </div>
      {hasConcentrationWarning && (
        <div
          className="flex items-center gap-2 mb-3 px-3 py-2 rounded-md border"
          style={{ background: 'var(--color-warning)10', borderColor: 'var(--color-warning)30' }}
        >
          <AppTooltip
            title="Alerta de Concentración"
            description="Se activa cuando un solo metal supera el porcentaje máximo configurado en Umbrales de Riesgo. Indica que tu cartera está poco diversificada."
          >
            <span className="text-xs font-caption" style={{ color: 'var(--color-warning)' }}>
              ⚠ {topMetal?.name} representa el {topMetal?.pct}% del inventario
            </span>
          </AppTooltip>
        </div>
      )}
      <div className="w-full h-48 md:h-56" aria-label="Gráfico de concentración de inventario por metal">
        <ResponsiveContainer width="100%" height="100%">
          <PieChart>
            <Pie
              data={data}
              cx="50%"
              cy="50%"
              innerRadius="55%"
              outerRadius="80%"
              paddingAngle={3}
              dataKey="value"
            >
              {data?.map((entry, index) => (
                <Cell key={index} fill={COLORS?.[index % COLORS?.length]} />
              ))}
            </Pie>
            <RechartsTooltip content={<CustomTooltip />} />
            <Legend
              wrapperStyle={{ fontSize: "11px", fontFamily: "IBM Plex Sans" }}
              iconType="circle"
              iconSize={8}
            />
          </PieChart>
        </ResponsiveContainer>
      </div>
    </div>
  );
}